import ArtDirectedImage from '@components/OptimizeImage/ArtDirectedImage';
import { I_Banner } from '@containers/Eat/typesIndex';
import { removeScripts } from '@utils/helper';

interface Props {
  banner: I_Banner;
}

export const PageBanner = ({ banner }: Props) => {
  return (
    <div className="pt-[154px]">
      <div className="container-fluid left grid grid-cols-[auto_65%] gap-20 max-2xl:grid-cols-[auto_60%] max-2xl:gap-10 max-md:flex max-md:flex-col max-md:gap-6">
        <div className="flex flex-col gap-8 pb-8 max-md:gap-3 max-md:pb-0">
          <h1 className="segTitle mt-auto mb-0">{banner?.title}</h1>
          <article
            dangerouslySetInnerHTML={{
              __html: removeScripts(banner?.description) || '',
            }}
          />
        </div>
        <div className="aspect-11/6 w-full">
          <ArtDirectedImage
            className="size-full"
            desktopSrc={banner?.imageResize?.thumb1920}
            mobileSrc={banner?.imageMobileResize?.thumb1920}
            sizes="(max-width: 768px) 100vw, (max-width: 1440px) 100vw, 1335px"
            priority
          />
        </div>
      </div>
    </div>
  );
};
